import React from 'react'
import styles from './index.module.css'
import Select from '../../../components/ModalInputs/Select'

const closedOptions = [
    { value: '', name: 'Все' },
    { value: 0, name: 'Открытые' },
    { value: 1, name: 'Закрытые' }
];

const Index = ({ params, handleChange, courses }) => {
    return (
        <div className={styles.container}>
            <div className={styles.inputsRow}>
                <div className={styles.container_select}>
                    <Select
                        value={params.closed ?? ''}
                        name='closed'
                        label='Статус'
                        onChange={(e) => handleChange(e.target.name, e.target.value)}>
                        {closedOptions.map(el => (
                            <option key={el.value} value={el.value}>{el.name}</option>
                        ))}
                    </Select>
                </div>
                <div className={styles.container_select}>
                    <Select
                        value={params.xp_key || ''}
                        name='xp_key'
                        label='Дисциплина'
                        onChange={(e) => handleChange(e.target.name, e.target.value)}>
                        <option value=''>Все</option>
                        {courses?.map(el => (
                            <option key={el.xp_key || el.id} value={el.xp_key || el.id}>{el.name}</option>
                        ))}
                    </Select>
                </div>
            </div>
        </div>
    )
}

export default Index
